import React, { Component } from 'react';
import {
    ResponsiveContainer, Tooltip, Legend, PieChart, Pie, Cell
} from 'recharts';

import './chart-water-balance.style.css';

const RADIAN = Math.PI / 180;
export class ChartWaterBalance extends Component {
    constructor(props) {
        super(props);
    }

    shuffleArray = (a) => {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }

    renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index }) => {
        const RADIAN = Math.PI / 180;
        // eslint-disable-next-line
        const radius = 25 + innerRadius + (outerRadius - innerRadius);
        // eslint-disable-next-line
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        // eslint-disable-next-line
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="#8884d8"
                textAnchor={x > cx ? "start" : "end"}
                dominantBaseline="central"
            >
                {`${(percent * 100).toFixed(1)}%`}
            </text>
        );
    }

    render() {
        const data_default = [{ name: 'Unknown', value: 100 }];

        let data = this.props.data;

        if (data.length === 0) {
            data = data_default;
        }

        let COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#F39A9D','#6DB1BF','#FF9FE5','#FFD4D4','#FF858D','#D2CCA1','#DBD4D3','#F5F8DE',
                '#FAFF7F','#FF88DC','#91A6FF','#FF858D','#E6CCBE','#A8D5E2','#FFD449',
        '#E36397','#EFF2EF','#FFEE88','#00CC99','#6BD425','#FFFC31','#E94F37','#EAEAEA','#F2F230','#C2F261','#91F291',
        '#61F2C2','#30F2F2','#E6AACE','#FFAC81','#FF928B','#FEC3A6','#EFE9AE','#CDEAC0','#F8FCDA','#E3E9C2','#F9FBB2','#FF7700',
        '#D8D4F2','#1AC8ED','#8FE388','#DBAD6A','#CF995F','#D0CE7C','#D4F4DD','#17BEBB','#F49D37','#3F88C5','#F22B29','#D5E1A3','#E2F89C','#E0FF4F'];
        COLORS = this.shuffleArray(COLORS);

        return (
            <div style={{ width: '100%', height: '100%' }}>
                <ResponsiveContainer>
                    {/* <LineChart width={500} height={500} data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                        <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                    </LineChart> */}

                    <PieChart className='pipeChart' onMouseEnter={this.onPieEnter}>
                        <Pie
                            dataKey="value"
                            data={data}
                            cx="50%"
                            cy="50%"
                            labelLine={true}
                            label={this.renderCustomizedLabel}
                            outerRadius={150}
                            fill="#8884d8"
                        >
                            {
                                data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
                            }
                        </Pie>
                        <Tooltip  />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>

            </div>
        )
    }
}

export default ChartWaterBalance



//code sample for customize label
// import React from "react";
// import { ResponsiveContainer, PieChart, Pie } from "recharts";
// import { Panel } from "react-bootstrap";

// const data = [{ name: "network 1", value: 2 }, { name: "network 3", value: 4 }];

// export default ({ name }) =>
//   <ResponsiveContainer width="100%" height={250}>
//     <PieChart height={250}>
//       <Pie
//         data={data}
//         cx="50%"
//         cy="50%"
//         outerRadius={100}
//         fill="#8884d8"
//         dataKey="value"
//         label={({
//           cx,
//           cy,
//           midAngle,
//           innerRadius,
//           outerRadius,
//           value,
//           index
//         }) => {
//           console.log("handling label?");
//           const RADIAN = Math.PI / 180;
//           // eslint-disable-next-line
//           const radius = 25 + innerRadius + (outerRadius - innerRadius);
//           // eslint-disable-next-line
//           const x = cx + radius * Math.cos(-midAngle * RADIAN);
//           // eslint-disable-next-line
//           const y = cy + radius * Math.sin(-midAngle * RADIAN);

//           return (
//             <text
//               x={x}
//               y={y}
//               fill="#8884d8"
//               textAnchor={x > cx ? "start" : "end"}
//               dominantBaseline="central"
//             >
//               {data[index].name} ({value})
//             </text>
//           );
//         }}
//       />
//     </PieChart>
//   </ResponsiveContainer>;

